export default __webpack_public_path__ + "images/logout.eabd9dc65302a7a2affbc542b588da7f.svg";